/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NoteUpdateReqVo
 */
export interface NoteUpdateReqVo {
    /**
     * 站内信ID
     * @type {number}
     * @memberof NoteUpdateReqVo
     */
    id: number;
    /**
     * 标题
     * @type {string}
     * @memberof NoteUpdateReqVo
     */
    title: string;
    /**
     * 内容
     * @type {string}
     * @memberof NoteUpdateReqVo
     */
    content: string;
}

/**
 * Check if a given object implements the NoteUpdateReqVo interface.
 */
export function instanceOfNoteUpdateReqVo(value: object): value is NoteUpdateReqVo {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function NoteUpdateReqVoFromJSON(json: any): NoteUpdateReqVo {
    return NoteUpdateReqVoFromJSONTyped(json, false);
}

export function NoteUpdateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NoteUpdateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'content': json['content'],
    };
}

export function NoteUpdateReqVoToJSON(json: any): NoteUpdateReqVo {
    return NoteUpdateReqVoToJSONTyped(json, false);
}

export function NoteUpdateReqVoToJSONTyped(value?: NoteUpdateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'content': value['content'],
    };
}

